const { ofetch } = require("ofetch");

$(function() {
    var Form1A = {

        //PROPERTIES
        options: {
            posting:false,
        },
    
        /**
        * Objects Property - contains references to primary jQuery objects
        *
        */
        objs: {
            $Form1AForm: $('.component-form-1A__form')
        },
    
        //METHODS
        /**
        * Intialize the application
        *
        */
        init:function() {
            var that = this;
    
            that.ComponentEvents();
        }, //END METHOD
    
        /**
        * Submit the form
        *
        */
        FormSubmit:async function($FormInstance) {
            const FormInstanceData = new FormData($FormInstance[0]);
            const data_pairs = {};
            //const action = $element.data('form1a-fetch');
            for (const x of FormInstanceData.entries()) {
                
                //Handle Arrays / checkboxs / multiselects etc..
                if (data_pairs[x[0]]) {
                    if (!Array.isArray(data_pairs[x[0]])) {
                        var value = data_pairs[x[0]];
                        data_pairs[x[0]] = [value];
                        data_pairs[x[0]].push(x[1])
                    } else {
                        data_pairs[x[0]].push(x[1])
                    }
                    
                    //otherwise proceed as ususal
                } else {
                    data_pairs[x[0]] = x[1];
                }
            }
            //data_pairs['hp_message']
            const action = $FormInstance.data('form1a-fetch').replace('ph', data_pairs['hp_message']);
            const response = await ofetch(action, {
                method: "POST",
                body:JSON.stringify(data_pairs)
            });
        },

        /**
        * Component Events
        *
        */
        ComponentEvents:function() {
            var that = this;
            that.objs.$Form1AForm.on('click', '.component-form-1A__btn-submit--trigger', function(event) {
                var $this = $(this);
                var $FormInstance = $this.parents('.component-form-1A__form');
                //var action = $FormInstance.data('form-action');
                
                //block it
                if (that.options.posting) { event.preventDefault(); return false; } else { that.options.posting = true; }
    
                //validate it
                if ($FormInstance[0].checkValidity()) {
                    //remove errors
                    $('.component-form-1A__input-wrapper', $FormInstance).removeClass('component-form-1A__input-wrapper--error-present');

                    //submit it
                    that.FormSubmit($FormInstance)
                    
                    //something it
                    $('.component-form-1A__input--validate', $FormInstance).each(function() { $(this).prop('readonly', true).attr('disabled', true); });
                    $FormInstance.addClass('component-form-1A__form--submitted');
                    $('.component-form-1A__btn-submit', $FormInstance).removeClass('component-form-1A__btn-submit--trigger');
    
                    that.options.posting = false;
                } else {
                    $('.component-form-1A__input-wrapper', $FormInstance).removeClass('component-form-1A__input-wrapper--error-present');
                    $('.component-form-1A__input--validate', $FormInstance).each(function() {
                        !$(this)[0].validity['valid'] && $(this).parents('.component-form-1A__input-wrapper').addClass('component-form-1A__input-wrapper--error-present');
                    });
                    that.options.posting = false;
                }
    
                event.preventDefault();
            });
        }, //END METHOD
    }

    //initialize
    Form1A.init();
});
